import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../auth/AuthContext'
import { apiFetch } from '../api/client'
import type { Me } from '../api/types'

// useMe loads the current owner profile + subscription flags from
// GET /v1/me. Cached aggressively because gating UI reads from it on
// every page; invalidate after billing changes (Checkout return,
// Customer Portal close) so flag flips show up immediately.
export function useMe() {
  const { idTokenProvider, user } = useAuth()
  return useQuery({
    queryKey: ['me'],
    queryFn: ({ signal }) => apiFetch<Me>('/v1/me', idTokenProvider, { signal }),
    enabled: !!user,
    staleTime: 60_000,
    // A transient /v1/me failure must not collapse a paid user to the
    // locked-upsell state (FE-3) — retry a couple of times before the
    // consuming UI (SubscriptionGate) shows its neutral retry banner.
    retry: 2,
  })
}
